import * as React from "react";

const InterventionIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="22"
    fill="inherit"
    viewBox="0 0 24 22"
  >
    <g clipPath="url(#clip0_1134_76)">
      <path
        fill="inherit"
        d="M19 0H5a5.006 5.006 0 0 0-5 5v12a5.006 5.006 0 0 0 5 5h14a5.006 5.006 0 0 0 5-5V5a5.006 5.006 0 0 0-5-5m3 17a3.003 3.003 0 0 1-3 3H5a3.004 3.004 0 0 1-3-3V5a3.004 3.004 0 0 1 3-3h14a3.004 3.004 0 0 1 3 3zM19 6a1 1 0 0 1-1 1h-7a1 1 0 1 1 0-2h7a1 1 0 0 1 1 1M8 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m11 5a1 1 0 0 1-1 1h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 1 1M8 11a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m11 5a1 1 0 0 1-1 1h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 1 1M8 16a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_1134_76">
        <path fill="#fff" d="M0 0h24v22H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default InterventionIcon;
